class Devices {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');

        this.editDeviceEvents();
        this.editDeviceInput();
        this.exportDevicesToCsv();
    }
    editDeviceEvents(){
        const thisClass = this;
        /** When user click on edit button redraw modal form and get member values */
        $(document).on('click', '.edit-device', function(e) {
            let showLogs = false;
            if($(this).hasClass('show-logs')){
                showLogs = true;
            }
            let vpnUserID = $(this).parent()[0].id;
            thisClass.showEditDeviceModal(vpnUserID, showLogs);
        });
        /** If url contains #edit-device - show device */
        if(window.location.href.includes('edit-device') && new URLSearchParams(window.location.search).get('deviceID')){
            thisClass.showEditDeviceModal(new URLSearchParams(window.location.search).get('deviceID'));
        }
    }
    /** Redraw device form by deviceID */
    showEditDeviceModal(deviceID, showLogs = false){
        new ModalLoading();
        naja.makeRequest('GET', '/devices/?do=getDeviceInfo', {
            'deviceID': deviceID,
            'organizationID': this.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response){
                let editDeviceModal = document.getElementById('edit_device_modal');
                this.editDeviceFormValidation();
                KTScroll.createInstances();

                this.initDeleteDevice(editDeviceModal, response.deviceInfo);

                // Init all popovers
                const popoverTriggerList = [].slice.call(document.querySelectorAll('#edit_device_modal [data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });

                this.initDevicePostureCheckLogs(response.deviceInfo.uuid, showLogs);

                this.hideGeneralModals(editDeviceModal);
                new ModalLoading(editDeviceModal);
            }
        }).catch(error => {
            new ModalLoading();
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }
    initDeleteDevice(editDeviceModal, deviceInfo){
        const thisClass = this;
        const deleteDeviceButton = editDeviceModal.querySelector('.delete-device');
        if(deleteDeviceButton){
            deleteDeviceButton.addEventListener('click', function () {
                Swal.fire({
                    html: `<span class="text-center text-primary">Device `+(deviceInfo.name !== undefined ? `<b>`+deviceInfo.name+`</b> ` : ``)+`is going to be completely deleted!</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/devices?do=removeDevice&organizationID='+thisClass.organizationID+'&deviceID='+deviceInfo.uuid)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        if(result.value) {
                            toastr.success('Device has been deleted.');
                            bootstrap.Modal.getOrCreateInstance(editDeviceModal).hide();
                            new PageDatatableReload();

                            let numberOfDevicesElement = $(".number-of-devices");
                            if(numberOfDevicesElement){
                                numberOfDevicesElement.text(numberOfDevicesElement.text() - 1);
                            }
                        } else {
                            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                        }
                    }
                });
            });
        }
    }
    hideGeneralModals(editDeviceModal){
        let editMemberModal = document.getElementById('edit_team_member_modal');
        if(editMemberModal && editMemberModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editMemberModal).hide();
            new AddBackLinkToModal(editMemberModal, editDeviceModal);
        }
    }
    initDevicePostureCheckLogs(deviceID, showLogs = false){
        let modal = document.getElementById('edit_device_modal');
        const postureCheckLogsTab = modal.querySelector('.nav-link[href="#posture_check_logs_tab"]');
        if(!showLogs){
            let showLogsElements = modal.querySelectorAll('.show-logs');
            showLogsElements.forEach((element) => {
                element.addEventListener('click', function () {
                    bootstrap.Tab.getOrCreateInstance(postureCheckLogsTab).show();
                    if (!$.fn.DataTable.isDataTable('#edit-device-posture-check-datatable')) {
                        new DevicePostureCheckLogsDatatable('#edit-device-posture-check-datatable', deviceID);
                    }
                    KTMenu.createInstances();
                });
            });
            postureCheckLogsTab.addEventListener('click', function () {
                if (!$.fn.DataTable.isDataTable('#edit-device-posture-check-datatable')) {
                    new DevicePostureCheckLogsDatatable('#edit-device-posture-check-datatable', deviceID);
                }
                KTMenu.createInstances();
            });
        } else {
            bootstrap.Tab.getOrCreateInstance(postureCheckLogsTab).show();
            if (!$.fn.DataTable.isDataTable('#edit-device-posture-check-datatable')) {
                new DevicePostureCheckLogsDatatable('#edit-device-posture-check-datatable', deviceID);
            }
            KTMenu.createInstances();
        }
    }
    /** If user click on pencil next to text, transform it into input */
    editDeviceInput(){
        $(document).on('click', '#frm-generalForms-editDeviceForm-editDeviceForm .edit-alias', function(e) {
            let aliasDiv = $('#frm-generalForms-editDeviceForm-editDeviceForm .editable-alias');
            let editableInputAlias = $('#frm-generalForms-editDeviceForm-editDeviceForm .editable-input-alias');
            let removeAliasEditable = $('#frm-generalForms-editDeviceForm-editDeviceForm .remove-alias-editable');
            aliasDiv.removeClass('d-none');
            editableInputAlias.removeClass('d-none');
            removeAliasEditable.remove();
            $(this).remove();
        });
    }
    editDeviceFormValidation(){
        let form = document.getElementById('frm-generalForms-editDeviceForm-editDeviceForm');
        if(form){
            let submitButton = document.getElementById('edit_device_form_submit');
            let deleteButton = document.getElementById('edit_device_form_delete');

            /** validate form for team member */
            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'alias': {
                            validators: {
                                stringLength: {
                                    max: 64,
                                    message: 'Alias cannot be over 64 characters',
                                },
                                regexp: {
                                    regexp: /^[ěščřžýáíéóúůďťňĎŇŤŠČŘŽÝÁÍÉÚŮa-zA-Z0-9' _.-]*$/,
                                    message: 'Only these special characters are allowed. (_.-)',
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        })
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.classList.contains('d-none')){
                    // Get the icon plugin instance
                    const iconPlugin = validator.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            }).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                new DismissModal('edit_device_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
                if(deleteButton){
                    deleteButton.disabled = true;
                }
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('edit_device_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
                if(deleteButton){
                    deleteButton.disabled = false;
                }
            });
        }
    }
    exportDevicesToCsv(){
        let thisClass = this;
        let buttons = document.querySelectorAll('[data-action="export-devices-to-csv"]');
        buttons.forEach((button) => {
            button.addEventListener('click', function () {
                thisClass.downloadFile("/devices/get-devices-csv-export?organizationID="+thisClass.organizationID, 'devices.csv');
            });
        });
    }
    downloadFile(url, fileName){
        let loadingModal = document.getElementById('loading-modal');
        let hideModal = function () {
            setTimeout(function() {
                bootstrap.Modal.getOrCreateInstance(loadingModal).hide();
            }, 100);
        }
        new bootstrap.Modal(loadingModal).show();
        $.ajax({
            url: url,
            method: 'GET',
            xhrFields: {
                responseType: 'blob'
            },
            success: function (data) {
                const a = document.createElement('a');
                const url = window.URL.createObjectURL(data);
                a.href = url;
                a.download = fileName;
                document.body.append(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                hideModal();
                toastr.success('Devices has been successfully downloaded!')
            },
            error: function (request, status, error) {
                hideModal();
                toastr.error('Unexpected error occurred. Please try it again later or contact our support team.')
            }
        });
    }
}
window.Devices = Devices;